/**
 * @graph-stack ac-mens-hub
 * @graph-domain Operations
 * @graph-business FAQ監視 API クライアント。作業リストの取得と対応方針の保存を提供する。
 * @graph-connects /faq-monitor/worklist [calls] FAQ監視の作業リスト取得
 * @graph-connects /faq-monitor/alf-performance [calls] ALF実績の取得
 * @graph-connects /faq-monitor/dispositions [calls] 対応方針の保存
 */

import { request } from './api.js';
import type {
  FaqAlfPerformanceQuery,
  FaqAlfPerformanceResponse,
  FaqDisposition,
  FaqDispositionInput,
  FaqWorklistResponse,
} from '../types/faq-monitor.js';

/**
 * ALF実績のクエリ文字列を組み立てる。
 * 期間は未指定にできる（API 側が前日までの直近28日を既定にする）。
 * @graph-connects none
 */
export function buildAlfPerformanceQuery(query: FaqAlfPerformanceQuery): string {
  const params = new URLSearchParams({ minCited: String(query.minCited) });
  if (query.from !== undefined) params.set('from', query.from);
  if (query.to !== undefined) params.set('to', query.to);
  return params.toString();
}

/** @graph-connects buildAlfPerformanceQuery [calls] ALF実績のクエリ文字列の組み立て */
export const faqMonitorApi = {
  getWorklist: (runDate?: string): Promise<FaqWorklistResponse> =>
    request<FaqWorklistResponse>(
      runDate === undefined
        ? '/faq-monitor/worklist'
        : `/faq-monitor/worklist?runDate=${encodeURIComponent(runDate)}`,
    ),
  getAlfPerformance: (query: FaqAlfPerformanceQuery): Promise<FaqAlfPerformanceResponse> =>
    request<FaqAlfPerformanceResponse>(
      `/faq-monitor/alf-performance?${buildAlfPerformanceQuery(query)}`,
    ),
  setDisposition: (hash: string, input: FaqDispositionInput): Promise<FaqDisposition> =>
    request<FaqDisposition>(`/faq-monitor/dispositions/${encodeURIComponent(hash)}`, {
      method: 'PUT',
      body: JSON.stringify(input),
    }),
};
